import React from 'react';
import { IProps } from './types';
import _ from 'lodash';

const Table: React.FC<IProps> = (props) => {
  /**
   * @description 建立左側標頭 (手機版)
  */
  const handleCreateTitleMobile = (lmtContent:any) => {
    const titles = new Array(0);
    _.forEach(lmtContent, (content:string[], index:number) => {
      if (!content[0]) return;

      titles.push(content[0]);
    });

    return _.map(titles, (str:string, index:number) => {
      return <div className="element__table-horizon-y-title" key={index}>{str}</div>;
    });
  };

  /**
   * @description 建立欄位內容集合
   * @param startIndex 迴圈起始 index
   * @param 顯示欄位數
  */
  const handleCreateTbody = (vehicleLmt:string[][]) => {
    const tbody = new Array(0);

    for (let i = 0; i < vehicleLmt.length; i += 1) {
      const child = handleCreateLmtBody(vehicleLmt[i], i);
      tbody.push(child);
    }

    return tbody;
  };

  /**
   * @description 建立欄位內容
  */
  const handleCreateLmtBody = (content:string[], index:number) => {
    if (content.length === 0) return;

    const childs = new Array(0);
    if (index === 0) {
      _.forEach(content, (str:string, index:number) => {
        childs.push(<th key={index} className="element__table-horizon-x-title">{str}</th>);
      });
    } else {
      _.forEach(content, (str:string, index:number) => {
        if (index === 0) {
          childs.push(<th key={index} className="element__table-horizon-y-title">{str}</th>);
        } else {
          let childVal:any = str;
          if (str && str.toUpperCase() === 'V') childVal = <i className="element__tick-icon" />;
          childs.push(<td key={index}>{childVal}</td>);
        }
      });
    }

    return (
      <tr key={index}>
        {childs}
      </tr>
    );
  };

  return props.vehicleLimits && props.vehicleLimits[0].length > 0 ? (
    <div className="flow-remind__table">
      <div className="flow-remind__table-title">網路投保 VS 網路要保</div>
      <div className="element__table-horizon">
        <div className="element__table-horizon-y-fixed">
          {handleCreateTitleMobile(props.vehicleLimits)}
        </div>
        <div className="element__table-horizon-wrap">
          <div className="element__table-horizon-container">
            <table>
              <tbody>
                {handleCreateTbody(props.vehicleLimits)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Table;
